import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MaintenanceSchedulesCard from "../MaintenanceSchedules/MiniComponents/MaintenanceSchedulesCard";
import { getAllMyTasks } from "../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";
import { useDispatch, useSelector } from "react-redux";

export default function Tasks() {
  const dispatch = useDispatch();
  const { allMyTasks } = useSelector((state) => state.maintenanceSchedule);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [tasks, setTasks] = useState();
  useEffect(() => {
    dispatch(getAllMyTasks(currentPage));
  }, [dispatch, currentPage]);
  useEffect(() => {
    if (allMyTasks) {
      console.log(allMyTasks);
      setTasks(allMyTasks.data);
    }
    if (allMyTasks?.pagination) {
      setTotalPages(Math.ceil(allMyTasks.pagination.total / allMyTasks.pagination.limit));
    }
  }, [allMyTasks]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
    console.log(currentPage);
  };

  return (
    <div className="main">
      <section className="maintenance-items">
        <div>
          <h1 className="text-white">التاسكات</h1>
        </div>
        <div className="container-fluid">
          <div className="row justify-content-between align-items-center mb-5 mt-3">
            <div className="col-md-4 d-flex justify-content-md-start justify-content-center mb-3">
              <div className="card py-2 px-3">
                <p className="mb-0 primary-100">
                  عدد التاسكات: <span className="primary-100">{tasks?.length || 0}</span>
                </p>
              </div>
            </div>
            <div className="col-md-4 text-center mb-3">
              <input type="search" placeholder="ابحث ..." className="form-control search" />
            </div>
            <div className="col-md-4 text-md-end text-center">
              {/* <Link className="btn btn-primary text-white" to={"/AddMaintenanceSchedule"}>
                إضافة جدول
              </Link> */}
            </div>
          </div>
          <div className="row">
            {tasks &&
              tasks?.length > 0 &&
              tasks.map((maintenanceSchedule) => (
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
                  <MaintenanceSchedulesCard maintenanceSchedule={maintenanceSchedule} />
                </div>
              ))}
          </div>
          {totalPages > 1 && (
            <div className="row mt-4">
              <div className="col-12 d-flex justify-content-center">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        السابق
                      </button>
                    </li>
                    {[...Array(totalPages).keys()].map((page) => (
                      <li key={page + 1} className={`page-item ${currentPage === page + 1 ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                          {page + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        التالي
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
